import { BatchItem } from "@wingspanhq/wingspan-api-sdk";

export type FailedImportBatchItemError = {
  id: string;
  label: string;
  value: number;
};

/**
 * Failed rows grouped by the reason they failed. v1 carried the message in the
 * item's `metadata.errorMessage`; v3 puts it in `statusReason`.
 */
export const selectorFailedImportBatchItemErrors = (
  items: BatchItem[]
): FailedImportBatchItemError[] => {
  const countByReason = items.reduce<Record<string, number>>((acc, item) => {
    const reason = item.statusReason ?? "";
    acc[reason] = (acc[reason] ?? 0) + 1;
    return acc;
  }, {});

  return Object.keys(countByReason).map(reason => ({
    id: reason,
    label: reason,
    value: countByReason[reason]
  }));
};
